<template>
  <transition name="slide-fade">
    <div>
      <div v-if="!isProcessed" class="row scenario shadow rounded bg-white mx-2 pt-4 d-flex">
        <div class="col-12 align-self-start d-flex justify-content-between top-bar">
          <div class="flex-start align-self-start">
            <h4 class="font-weight-bold" style="margin-bottom:0.1rem">{{ name }}</h4>
            <p>This scenario is currently processing. please check back later.</p>
          </div>
        </div>
      </div>
      <div
        v-if="isProcessed"
        class="position-relative row scenario shadow rounded bg-white mx-2 pt-4 d-flex"
      >
        <router-link
          class="w-100 sm-w-50"
          :to="{ name: 'scenario-edit', params: { uuidId: uuidId } }"
          v-if="!isPublishable"
        >
          <div
            class="unpublished-alert alert alert-info w-100 top-bar"
          >
            <em class="font-weight-bold">
              This scenario is unpublished. Click here to add a description, categories
              and tags.
            </em>
          </div>
        </router-link>
        <div
          v-bind:class="{ noColor: !isPublishable }"
          class="col-12 align-self-start d-flex justify-content-between top-bar"
        >
          <div
            v-bind:class="{ noColor: !isPublishable }"
            class="flex-start align-self-start"
          >
            <div class="d-flex align-items-center">
              <div v-if=" currentPrivacyLevel === 0" class>
                <i class="material-icons privacy">lock</i>
              </div>

              <div v-else class>
                <i class="material-icons privacy">lock_open</i>
              </div>
              <h4 class="font-weight-bold" style="margin-bottom:0.1rem">
                <router-link :to="{ name: 'scenario-view', params: { uuidId: uuidId } }">{{ name }}</router-link>
              </h4>
            </div>
            <div
              v-bind:class="{ noColor: !isPublishable }"
              class="scenario-stats my-2 d-flex flex-column"
            >
              <div class="d-flex align-items-center">
                <i class="material-icons text-secondary">star</i>
                <em>Favourited:</em>
                <span class="element-label">
                  <em>{{ numberFavourites }}</em>
                </span>
              </div>

              <div class="d-flex align-items-center">
                <i class="material-icons text-secondary">save_alt</i>
                <em>Downloads:</em>
                <span class="element-label">
                  <em>{{ numDownloads }}</em>
                </span>
              </div>
            </div>
          </div>

          <div class="text-right sm-align-self-end">
            <ScenarioActions :uuidId="uuidId" :isFavouritedByUser="isFavouritedByUser"></ScenarioActions>
          </div>
        </div>

        <div
          v-bind:class="{ noColor: !isPublishable }"
          class="col-12 d-flex align-self-center sm-justify-content-between flex-column flex-sm-row"
        >
          <div class="image-wrapper my-1 align-self-center mr-3">
            <div class="d-flex mb-2">
              <div class="privacy-toggles" v-if="isPublishable">
                <div class="btn-group personal-settings" role="group" aria-label="Basic example">
                  <button
                    :class="{ 'current-privacy-level btn-primary ': currentPrivacyLevel === 2,
                    btn: true,
                    'btn-secondary': true
                  }"
                    @click="changePrivacyLevel(2)"
                  >Public</button>
                  <button
                    :class="{
                    'current-privacy-level btn-primary ': currentPrivacyLevel === 0,
                    btn: true,
                    'btn-secondary': true
                  }"
                    @click="changePrivacyLevel(0)"
                  >Private</button>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column mb-2">
              <router-link
                :to="{ name: 'scenario-edit', params: { uuidId: uuidId } }"
                class="w-100"
              >
                <button class="d-flex align-items-center btn btn-primary w-100 edit-button d">
                  <i class="material-icons mr-2 d-flex align-items-center">edit</i> Update Details
                </button>
              </router-link>
              <!--  :href="'https://s3.us-west-2.amazonaws.com/dev.isimulate.scenario.web.editor/index.html?editscenario='+ uuidId">-->
              <a v-if="!isOnNative" :href="webEditorUrl" class="w-100 mt-2">
                <button class="d-flex align-items-center btn btn-primary w-100 edit-button d">
                  <i class="material-icons mr-2 d-flex align-items-center">launch</i> Open Scenario
                </button>
              </a>
            </div>
            <router-link :to="{ name: 'scenario-view', params: { uuidId: uuidId } }">
              <img
                :src="deviceThumb"
                title
                style="width:100%; max-width: 200px; min-width:110px; height:auto; margin: auto"
              />
            </router-link>
          </div>
          <div class="desc-wrapper w-100 align-self-start w-60 mt-4 d-flex flex-column mr-3">
            <p class="d-none d-sm-block mb-0 w-65">{{ description }}</p>
            <ul class="scenario-tags d-flex flex-wrap px-0 my-3 w-100">
              <li
                v-bind:key="tag.id"
                v-for="tag in tags"
                v-bind:class="{ selected: tag.isCurrentlySelected }"
              >{{ tag.title }}</li>
            </ul>
          </div>
        </div>
        <div
          v-bind:class="{ noColor: !isPublishable }"
          class="d-none d-sm-block col-12 align-self-end mt-3 bg-light"
        >
          <ScenarioElements
            bind:fileSize="fileSize"
            :language="language"
            :durationInSeconds="durationInSeconds"
            :numChecklistItems="numChecklistItems"
            :numEvents="numEvents"
            :hasMedia="hasMedia"
            :hasSounds="hasSounds"
            :hasLabs="hasLabs"
          ></ScenarioElements>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Scenario from "./Scenario";
import ScenarioElements from "./ScenarioElements";
import ScenarioHelper from "../utils/scenario.helper";
import scenService from "./../services/scenarios.service";

export default {
  name: "MyScenario",
  extends: Scenario,
  components: {
    ScenarioElements
  },
  computed: {
    isOnNative() {
      return this.$store.getters.getIsOnNative;
    },
    webEditorUrl() {
      return process.env.VUE_APP_CONTROL_DOMAIN + `?editscenarioid=${this.uuidId}&editscenarioname=${this.name}`;
    }
  },
  methods: {
    changePrivacyLevel(newLevel) {
      let data = new FormData();
      data.append("newLevel", newLevel);
      scenService.changePrivacyLevel(data, this.uuidId).then(response => {
        this.currentPrivacyLevel = Number(response.newLevel);
      });
    },
    updateFavouriteScenariosList() {
      this.$parent.updateFavouriteScenariosList();
    }
  },
  updated() {
    this.deviceThumb = require("../assets/device/" + ScenarioHelper.getFilenameForDeviceThumb(this.deviceId));
  },
  data: function() {
    return {
      currentPrivacyLevel: this.privacyLevel,
      deviceThumb: require("../assets/device/" + ScenarioHelper.getFilenameForDeviceThumb(this.deviceId))
    };
  },
  props: {
    privacyLevel: Number,
    isPublishable: Boolean,
    isProcessed: Boolean,
    uuidId: String,
    name: String,
    deviceId: Number
  }
};
</script>
<style scoped>
.privacy-toggles .btn-group {
  width: 200px !important;
}
.noColor {
  filter: grayscale();
  opacity: 0.7;
}
.scenario {
  margin-bottom: 30px;
  min-height: 400px;
  overflow: hidden;
}
.bg-blue {
}
.private-wrapper {
  z-index: 0;
  opacity: 0.09;
  height: 100%;
}

.private-wrapper img {
}

.scenario-contributed-by {
  text-align: right;
}
.scenario-elements {
  padding: 0;
  margin: 0;
}
.scenario-elements li {
  display: inline-block;
}
.scenario-tags li {
  margin-right: 10px;
}
.scenario-tags li {
  display: inline-block;
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
  border-radius: 7px;
  padding: 4px;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}
.contribution-element {
  display: flex;
}

.contribution-element .element-label {
  margin-right: 5px;
  white-space: nowrap;
}

.alert-warning {
  margin-top: -12px;
}

.personal-settings .btn {
  flex: 1;
  width: 50;
}

.share-button {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.edit-button {
  /* border-top-left-radius: 0;
  border-bottom-left-radius: 0; */
  max-width: 200px !important;
}

.desc-wrapper p {
  max-width: 85%;
}
li .tiny-span {
  font-size: 12px;
  color: #CB2E37;
  margin-right: 7px;
}

i.privacy {
  font-size: 50px;
  color: #6c757d;
}

.unpublished-alert {
  background-color: #CB2E37;

  text-align: center;
  border: none;
  border-radius: 0px;
}

.unpublished-alert em {
  color: #ffffff;
}

@media (max-width: 575.98px) {
  .top-bar {
    flex-direction: column;
  }
  .scenario h3 {
    display: block;
    width: 100%;
    text-align: left !important;
  }
  .sccenario #actions {
    width: 100%;
  }
  .privacy-toggles {
    width: 100%;
  }

  .privacy-toggles .btn-group {
    width: 100% !important;
  }

  .edit-button {
    max-width: 100% !important;
  }
}
</style>
